import api from "../api.js";

export const uploadMediaApi = async (payload) => {
  const { data } = await api.post("/media", payload);
  return data;
};

export const fetchMyMedia = async () => {
  const { data } = await api.get("/media/my");
  return data;
};

export const fetchAllMedia = async () => {
  const { data } = await api.get("/media/all");
  return data;
};

export const updateMediaStatus = async (id, status) => {
  const { data } = await api.put(`/media/${id}/status`, { status });
  return data;
};
